export default {
  // Inquiry Management
  inquiryManagement: {
    title: 'Inquiry Management',
    description: 'Manage customer inquiries process',

    // Enum translations
    enums: {
      inquiryTarget: {
        CLIENT: 'Business',
        SUPPLIER: 'Supplier'
      },
      payment: {
        PREPAID: 'Prepaid',
        COLLECT: 'Collect',
        '1': 'Prepaid',
        '2': 'Collect',
        '3': 'Prepaid/Collect'
      },
      airServiceType: {
        CONSOL: 'Consol',
        FULL_PALLET: 'Full Pallet',
        BLOCK_SPACE: 'Block Space',
        FULL_CHARTER: 'Full Charter',
        '1': 'Consol',
        '2': 'Full Pallet',
        '3': 'Block Space',
        '4': 'Full Charter'
      },
      railServiceType: {
        CONTAINER: 'Container',
        TRUCK: 'Full Truck',
        BULK: 'Bulk'
      },
      railRouteType: {
        MIDDLE: 'Middle Route',
        NORTH: 'North Route',
        SOUTH: 'South Route',
        SOUTHEAST_ASIA: 'Southeast Asia',
        CENTRAL_ASIA: 'Central Asia',
        中线: 'Middle Route',
        北线: 'North Route',
        南线: 'South Route',
        东南亚: 'Southeast Asia',
        中亚: 'Central Asia'
      },
      payment: {
        PREPAID: 'Prepaid',
        COLLECT: 'Collect'
      },
      airServiceType: {
        CONSOL: 'Consol',
        FULL_PALLET: 'Full Pallet',
        BLOCK_SPACE: 'Block Space',
        FULL_CHARTER: 'Full Charter'
      },
      railServiceType: {
        CONTAINER: 'Container',
        TRUCK: 'Full Truck',
        BULK: 'Bulk'
      },
      railRouteType: {
        MIDDLE: 'Middle Route',
        NORTH: 'North Route',
        SOUTH: 'South Route',
        SOUTHEAST_ASIA: 'Southeast Asia',
        CENTRAL_ASIA: 'Central Asia'
      }
    },

    // Tabs
    tabs: {
      fcl: 'FCL Inquiry',
      lcl: 'LCL Inquiry',
      air: 'Air Freight Inquiry',
      precarriage: 'Precarriage Inquiry',
      oncarriage: 'Oncarriage Inquiry',
      express: 'Express Inquiry',
      rail: 'Rail Inquiry'
    },

    // Toolbar buttons
    toolbar: {
      addInquiry: 'New Inquiry',
      addFclInquiry: 'New FCL Inquiry',
      addPrePortInquiry: 'New Pre-port Inquiry',
      addLastMileInquiry: 'New Last Mile Inquiry',
      addExpressInquiry: 'New Express Inquiry',
      addAirInquiry: 'New Air Freight Inquiry',
      addRailInquiry: 'New Rail Inquiry',
      batchOperations: 'Batch Operations ({count})',
      batchExport: 'Batch Export',
      batchExportExcel: 'Batch Export Excel',
      batchExportCsv: 'Batch Export CSV',
      batchDelete: 'Batch Delete'
    },

    // Table column headers
    columns: {
      inquiryNo: 'Inquiry No.',
      source: 'Inquiry Source',
      inquirerId: 'Inquirer',
      inquiryStatus: 'Inquiry Status',
      prePortQuotationStatus: 'First-leg Quotation Status',
      trunkLineQuotationStatus: 'Main-leg Quotation Status',
      lastMileQuotationStatus: 'Last-mile Quotation Status',
      expressQuotationStatus: 'Express Quotation Status',
      consultationStatus: 'Consultation Status',
      loadMode: 'Load Mode',
      routeType: 'Route Type',
      serviceType: 'Service Type',
      paymentTerm: 'Payment Term',
      expressCarrier: 'Express Carrier',
      transportTerms: 'Transport Terms',
      expectedSailingTime: 'Expected Sailing Time',
      expectedTransitTime: 'Expected Transit Time',
      seaEq: 'Container Type & Quantity',
      cargoReadyTime: 'Cargo Ready Time',
      palletNature: 'Cargo Nature',
      carrierId: 'Carrier',
      directTransit: 'Direct/Transit',
      routeId: 'Route',
      loadingPortId: 'Port of Loading',
      dischargingPortId: 'Port of Discharge',
      destinationPortId: 'Port of Discharge (POD)',
      cargoType: 'Cargo Type',
      cargoInfo: 'Cargo Info',
      originAddress: 'Origin',
      destinationAddress: 'Destination',
      loadingAirportId: 'Origin Airport',
      destinationAirportId: 'Destination Airport',
      airCarrierId: 'Airline',
      railCarrierId: 'Railway Company',
      railRouteType: 'Route Type',
      loadingRailwayStationId: 'Origin Station',
      destinationStationId: 'Destination Station',
      quantity: 'Pieces',
      unNo: 'UN No.',
      hazardClass: 'Hazard Class',
      cargoDescription: 'Cargo Name',
      hsCode: 'HS CODE',
      cargoValue: 'Cargo Value',
      cargoValueCurrency: 'Cargo Value Currency',
      onePriceSupported: 'One Price',
      deadLine: 'Quote Deadline',
      specialRequirements: 'Special Requirements',
      weight: 'Weight(KGS)',
      cubage: 'Volume(CBM)',
      inquiryNature: 'Inquiry Nature',
      totalQuantity: 'Quantity',
      totalWeight: 'Gross Weight(KGS)',
      totalCubage: 'Volume(CBM)',
      etd: 'ETD',
      eta: 'ETA',
      serviceTerm: 'Service Term',
      clientType: 'Client Type',
      clientTitle: 'Client Name',
      remarks: 'Remarks',
      createdBy: 'Created By',
      dateCreated: 'Created Time',
      submitDate: 'Submit Date',
      modifiedBy: 'Modified By',
      dateModified: 'Modified Time',
      quotationType: 'Quotation Type',
      inquiryTargetIds: 'Quoted Companies',
      actions: 'Actions'
    },

    // Filter placeholders
    placeholders: {
      quotationType: 'Please Select Quotation Type'
    },

    express: {
      pageTitle: {
        create: 'New Express Inquiry',
        edit: 'Edit Express Inquiry',
        view: 'View Express Inquiry',
        copy: 'Copy Express Inquiry'
      },
      sections: {
        ai: 'AI Recognition',
        basic: 'Basic Info',
        origin: 'Origin',
        destination: 'Destination',
        route: 'Route Info',
        cargo: 'Cargo Info',
        requirement: 'Quotation Requirements'
      },
      fields: {
        inquiryType: 'Inquiry Type',
        inquiryNature: 'Inquiry Nature',
        paymentTerm: 'Payment Term',
        loadMode: 'Load Mode',
        expressCarrier: 'Express Carrier',
        serviceType: 'Service Type',
        onePriceSupported: 'One Price',
        onePriceSupportedTip: 'Allow suppliers to quote an all-in one-price amount',
        cargoType: 'Cargo Type',
        source: 'Inquiry Source',
        palletNature: 'Cargo Nature',
        clientType: 'Client Type',
        client: 'Client',
        clientTitle: 'Client Name',
        cargoReadyTimeType: 'Cargo Ready Type',
        cargoReadyTimeRange: 'Cargo Ready Range',
        cargoReadyTimeDate: 'Cargo Ready Time',
        expectedSailingTime: 'Expected Sailing Time',
        deadLine: 'Quote Deadline',
        specialRequirements: 'Special Requirements',
        transportTerms: 'Trade Terms',
        originCountry: 'Origin Country',
        originProvince: 'Origin Province/State',
        originCity: 'Origin City',
        originDistrict: 'Origin District/County',
        originStreet: 'Origin Street',
        originDetail: 'Origin Detail',
        originPostalCode: 'Origin Postal Code',
        destCountry: 'Destination Country',
        destProvince: 'Destination Province/State',
        destCity: 'Destination City',
        destDistrict: 'Destination District/County',
        destStreet: 'Destination Street',
        destDetail: 'Destination Detail',
        destPostalCode: 'Destination Postal Code',
        postalCode: 'Postal Code',
        routeType: 'Route Type',
        quantity: 'Quantity',
        weight: 'Weight',
        actualWeight: 'Actual Weight(KGS)',
        actualTotalWeight: 'Actual Total Weight(KGS)',
        totalWeight: 'Cargo Total Weight(KGS)',
        totalWeightTon: 'Cargo Total Weight(Ton)',
        cubage: 'Volume',
        totalCubage: 'Total Volume(CBM)',
        length: 'Length',
        lengthCm: 'Length(CM)',
        width: 'Width',
        widthCm: 'Width(CM)',
        height: 'Height',
        heightCm: 'Height(CM)',
        dimensions: 'Single Piece Size(cm)',
        cargoDescription: 'Cargo Description',
        cargoName: 'Cargo Name',
        unNo: 'UN No.',
        hazardClass: 'Class',
        hsCode: 'HSCODE',
        cargoValue: 'Cargo Value',
        country: 'Country',
        province: 'Province/State',
        city: 'City',
        district: 'District/County',
        street: 'Town/Street',
        community: 'Community',
        detailAddress: 'Detail Address',
        warehouse: 'Warehouse',
        needPickup: 'Pickup Required',
        needDelivery: 'Delivery Required',
        needUpstairs: 'Upstairs Required',
        needLoadingUnloading: 'Loading/Unloading Required',
        expectedVehicleType: 'Expected Vehicle Type',
        expectedTransitTime: 'Expected Transit Time',
        pricingPreference: 'Pricing Preference',
        needSupplierProvide: 'Supplier Quotation Type',
        remarks: 'Remarks'
      },
      actions: {
        saveDraft: 'Save Draft',
        submit: 'Submit Inquiry',
        back: 'Back',
        recognize: 'Recognize',
        uploadRecognize: 'Upload & Recognize',
        matchRates: 'Match Rates',
        reset: 'Reset',
        uploadFile: 'Upload File',
        pasteText: 'Paste Text',
        recognizing: 'Recognizing...',
        clear: 'Clear',
        addCargo: 'Add Cargo'
      },
      ai: {
        uploadTitle: 'Click or drag to upload express inquiry files',
        uploadDesc: 'Supports JPG/PNG/PDF/Excel/Word',
        recognizedCount: '{count} fields recognized'
      },
      placeholders: {
        aiText: 'Paste express inquiry text, AI will try to fill route, cargo and requirement fields',
        input: 'Enter',
        select: 'Select'
      },
      options: {
        common: {
          any: 'Any'
        },
        specialRequirements: {
          signReceipt: 'Proof of Delivery',
          insurance: 'Insurance',
          cod: 'Cash on Delivery',
          none: 'None'
        },
        transitTime: {
          standard: 'Standard',
          express: 'Express',
          nextDay: 'Next Day',
          daysThreeToFive: '3-5 Days',
          daysFiveToSeven: '5-7 Days',
          withinOneDay: 'Within 1 Day',
          daysTwoToThree: '2-3 Days'
        },
        pricingPreference: {
          firstAdditional: 'First + Additional Weight',
          weightTier: 'Weight Tier',
          weightVolumeUnit: 'Per Piece (Weight/Volume Max)',
          trip: 'Flat Trip Price',
          km: 'Per Kilometer'
        },
        vehicleType: {
          fourTwo: '4.2m',
          sixEight: '6.8m',
          nineSix: '9.6m',
          thirteen: '13m',
          seventeenFive: '17.5m'
        }
      },
      messages: {
        loadFailed: 'Failed to load express inquiry',
        saveSuccess: 'Express inquiry saved',
        saveFailed: 'Failed to save express inquiry',
        resetSuccess: 'Reset successfully',
        aiTextRequired: 'Enter text to recognize first',
        aiFileRequired: 'Upload a file to recognize first',
        aiSuccess: 'AI recognition completed',
        aiFailed: 'AI recognition failed',
        matchRatesLoading: 'Querying matched rates...',
        matchRatesEmpty: 'No matched rates. Please adjust the query conditions.',
        matchRatesSuccess: '{count} matched rates found',
        matchRatesFailed: 'Failed to query matched rates',
        rateSelected: 'Rate selected',
        matchRequiredOrigin: 'Please fill in origin first',
        matchRequiredDestination: 'Please fill in destination first',
        originAddressRequired: 'Enter either an origin warehouse or a detailed address',
        destinationAddressRequired: 'Enter either a destination warehouse or a detailed address',
        deadlineFutureRequired: 'The quotation deadline must be later than the current time',
        cargoRowsRequired: 'Please complete cargo row {index}'
      },
      matchRates: {
        title: 'Matched Rates',
        selected: 'Selected',
        recommended: 'Recommended',
        noLimit: 'Match All',
        billingDetail: 'Billing Rule',
        surcharge: 'Surcharge',
        validity: 'Validity',
        surchargeCount: '{count} surcharge items'
      },
      detail: {
        title: 'Express Inquiry Details',
        totalQuotes: '{count} quotes',
        sentSuppliersWithCount: 'Sent Suppliers ({count})',
        contact: 'Contact',
        quotedAt: 'Quoted At',
        sections: {
          inquiryInfo: 'Inquiry Info',
          quotationSummary: 'Quotation Summary',
          negotiationRecords: 'Negotiation Records'
        },
        columns: {
          carrier: 'Express Carrier',
          serviceType: 'Service Type',
          billingModel: 'Billing Model',
          billingWeight: 'Billing Weight',
          baseFreight: 'Base Freight',
          minCharge: 'Minimum Charge',
          chargeableBase: 'Chargeable Base',
          surchargeTotal: 'Surcharge',
          totalAmount: 'Total Amount',
          validPeriod: 'Valid Period',
          confirmStatus: 'Confirm Status',
          consultStatus: 'Consult Status',
          importStatus: 'Import Status',
          consultationCount: 'Negotiations',
          chargeName: 'Charge Name',
          billingMode: 'Billing Mode',
          amount: 'Amount'
        },
        actions: {
          refresh: 'Refresh',
          confirmSupplier: 'Confirm Supplier',
          cancelConfirm: 'Cancel Confirm',
          negotiate: 'Negotiate',
          importRate: 'Import Rate'
        },
        status: {
          unconfirmed: 'Unconfirmed',
          confirmed: 'Confirmed',
          imported: 'Imported',
          notImported: 'Not Imported'
        },
        tags: {
          recommended: 'Recommended'
        },
        supplierStatus: {
          imported: 'Imported',
          quoted: 'Quoted',
          pendingQuote: 'Pending Quote'
        },
        help: {
          beforeConfirm: 'Unconfirmed quotations can be negotiated; quotations under negotiation cannot be initiated again, confirmed, or imported.',
          afterConfirm: 'Confirmed quotations cannot be negotiated, but can be imported or have their confirmation canceled.',
          afterImport: 'Imported quotations cannot be imported again or negotiated; confirmed quotations can still have their confirmation canceled.'
        },
        modal: {
          quotationDetail: 'Quotation Detail',
          pricingDetails: 'Pricing Details',
          calculation: 'Calculation',
          surchargeItems: 'Surcharge Items',
          unlimited: 'Unlimited',
          initiateConsultation: 'Initiate Negotiation',
          consultationRecords: 'Negotiation Records',
          supplier: 'Supplier',
          quotationNo: 'Quotation Plan',
          currentPrice: 'Current Price',
          expectedPrice: 'Expected Price',
          expectedPricePlaceholder: 'Enter the expected price; multi-currency text is supported',
          consultationNote: 'Negotiation Note',
          consultationNotePlaceholder: 'Enter the note for this negotiation round',
          consultationRound: 'Round {round}'
        },
        confirm: {
          cancelTitle: 'Cancel Confirmation',
          cancelContent: 'Are you sure you want to cancel this confirmed supplier?',
          importTitle: 'Import Rate',
          importContent: 'Are you sure you want to import this quotation into express rate maintenance?'
        },
        messages: {
          loadQuotationFailed: 'Failed to load express quotations',
          selectQuotationFirst: 'Select one quotation first',
          confirmConsultingDisabled: 'A quotation under negotiation cannot be confirmed',
          confirmUnavailable: 'This quotation cannot be confirmed in its current status',
          confirmSuccess: 'Supplier confirmed',
          confirmFailed: 'Failed to confirm supplier',
          cancelConfirmSuccess: 'Confirmation canceled',
          cancelConfirmFailed: 'Failed to cancel confirmation',
          importSuccess: 'Imported into rate maintenance',
          importFailed: 'Failed to import rate',
          importConsultingDisabled: 'An unconfirmed quotation under negotiation cannot be imported',
          importUnavailable: 'This quotation cannot be imported in its current status',
          consultSuccess: 'Negotiation initiated',
          consultFailed: 'Failed to initiate negotiation',
          consultUnavailable: 'This quotation cannot be negotiated in its current status',
          confirmedNegotiateDisabled: 'A confirmed quotation cannot be negotiated',
          importedNegotiateDisabled: 'An imported quotation cannot be negotiated',
          consultingNegotiateDisabled: 'This quotation is under negotiation; please wait for the supplier response',
          expectedPriceRequired: 'Expected price is required',
          loadConsultationFailed: 'Failed to load negotiation records'
        },
        emptyNegotiation: 'No negotiation records'
      }
    },

    air: {
      pageTitle: {
        create: 'New Air Inquiry',
        edit: 'Edit Air Inquiry',
        view: 'View Air Inquiry',
        copy: 'Copy Air Inquiry',
        tag: 'Air'
      },
      sections: {
        basic: 'Basic Info',
        route: 'Route Info',
        cargo: 'Cargo Info',
        dangerous: 'Dangerous Goods',
        serviceType: 'Service Type Fields',
        serviceBulk: 'Bulk Cargo Info',
        servicePallet: 'Full Pallet Info',
        serviceCharterSpace: 'Block Space Info',
        serviceFullCharter: 'Full Charter Info',
        prePort: 'Pre-port Pickup Address',
        lastMile: 'Last-mile Delivery Address',
        requirement: 'Quotation Requirements',
        ai: 'AI Recognition',
        special: 'Special Requirements'
      },
      fields: {
        inquiryNature: 'Inquiry Nature',
        paymentMethod: 'Payment Term',
        paymentTerm: 'Payment Term',
        serviceType: 'Service Type',
        serviceTerm: 'Service Term',
        transportTerm: 'Transport Term',
        cargoReadyTime: 'Cargo Ready Time',
        cargoReadyTimeType: 'Cargo Ready Type',
        cargoType: 'Cargo Type',
        hsCode: 'HSCODE',
        cargoValue: 'Cargo Value',
        onePriceSupported: 'All-in Price',
        onePriceSupportedTip: 'All-in price',
        deadLine: 'Quote Deadline',
        quoteDeadline: 'Quote Deadline',
        carrier: 'Airline',
        airline: 'Airline',
        createdBy: 'Created By',
        dateCreated: 'Created At',
        specialRequirements: 'Special Requirements',
        remarks: 'Remarks',
        loadingCountry: 'Origin Country',
        loadingCity: 'Origin City',
        loadingAirport: 'Origin Airport',
        destinationCountry: 'Destination Country',
        destinationCity: 'Destination City',
        destinationAirport: 'Destination Airport',
        originCountry: 'Origin Country',
        originCity: 'Origin City',
        originAirport: 'Origin Airport',
        destCountry: 'Destination Country',
        destCity: 'Destination City',
        destAirport: 'Destination Airport',
        quantity: 'Pieces',
        weight: 'Gross Weight',
        length: 'Length',
        width: 'Width',
        height: 'Height',
        palletCount: 'Pallet Count',
        inquiryNo: 'Inquiry No.',
        inquirySource: 'Inquiry Source',
        inquirer: 'Inquirer',
        inquiryStatus: 'Inquiry Status',
        quoteTarget: 'Quote Target',
        targetType: 'Target Type',
        prePortQuoteStatus: 'Pre-port Quote Status',
        trunkQuoteStatus: 'Trunk Quote Status',
        lastMileQuoteStatus: 'Last-mile Quote Status',
        negotiationStatus: 'Negotiation Status',
        clientName: 'Client',
        clientType: 'Client Type',
        clientTitle: 'Client Title',
        directTransit: 'Direct/Transit',
        expectedDeparture: 'Expected Departure',
        unNumber: 'UN No.',
        hazardClass: 'Hazard Class',
        hazardName: 'Hazard Name',
        productName: 'Product Name',
        cargoValueCurrency: 'Currency',
        country: 'Country',
        province: 'Province/State',
        city: 'City',
        district: 'District/County',
        street: 'Town/Street',
        detailAddress: 'Detail Address',
        postalCode: 'Postal Code',
        contactName: 'Contact',
        contactPhone: 'Contact Phone',
        airportStation: 'Origin Airport Cargo Station',
        destAirportStation: 'Destination Airport Cargo Station',
        deliveryAddressType: 'Delivery Type',
        fbaCode: 'FBA Code',
        warehouseCode: 'Warehouse Code',
        pieces: 'Pieces',
        unitPieces: 'Unit Pieces',
        unitGrossWeight: 'Unit Gross Weight(KGS)',
        lengthCm: 'Length(CM)',
        widthCm: 'Width(CM)',
        heightCm: 'Height(CM)',
        packageType: 'Package Type',
        temperature: 'Temperature(℃)',
        temperatureSimple: 'Temperature(℃)',
        ventilationDoor: 'Ventilation Door',
        airflow: 'Airflow',
        humidity: 'Humidity(%RH)',
        preCooling: 'Pre-cooling',
        totalPieces: 'Total Pieces',
        totalWeight: 'Total Gross Weight(KGS)',
        totalVolume: 'Total Volume(CBM)',
        uldType: 'ULD Type',
        piecesPerPallet: 'Pieces Per Pallet',
        grossWeightPerPallet: 'Gross Weight Per Pallet(KGS)',
        volumePerPallet: 'Volume Per Pallet(CBM)',
        palletLength: 'Pallet Length(CM)',
        palletWidth: 'Pallet Width(CM)',
        palletHeight: 'Pallet Height(CM)',
        uldEquipment: 'ULD Equipment',
        exclusiveCabin: 'Exclusive Cabin',
        maxLength: 'Max Length(CM)',
        maxWidth: 'Max Width(CM)',
        maxHeight: 'Max Height(CM)',
        handlingRequirements: 'Handling Requirements',
        preferredAircraft: 'Preferred Aircraft',
        aircraftName: 'Aircraft Name',
        estimatedTotalWeight: 'Estimated Total Weight(KGS)',
        estimatedTotalVolume: 'Estimated Total Volume(CBM)',
        grossWeight: 'Gross Weight(KGS)',
        volume: 'Volume(CBM)'
      },
      actions: {
        matchRates: 'Match Rates',
        reset: 'Reset',
        saveDraft: 'Save Draft',
        publish: 'Publish',
        submit: 'Submit Inquiry',
        back: 'Back to List',
        recognize: 'Recognize',
        clear: 'Clear',
        uploadFile: 'Upload File',
        pasteText: 'Paste Text',
        recognizing: 'Recognizing...',
        addContainerGroup: 'Add Container Group',
        delete: 'Delete',
        send: 'Send',
        switchToAi: 'Switch to AI Recognition',
        clearChat: 'Clear Chat',
        confirm: 'Confirm'
      },
      placeholders: {
        input: 'Enter',
        select: 'Select',
        optional: 'Optional',
        autoGenerate: 'Auto generated',
        currentUser: 'Current logged-in user',
        autoInferTargetType: 'Auto-inferred from quote target',
        clientName: 'Client name',
        selectClientType: 'Select client type',
        selectClient: 'Select client',
        enterClientTitle: 'Enter client title',
        multiAirline: 'Optional, multi-select supported',
        searchAirport: 'Search by airport code',
        selectDate: 'Select date',
        selectRange: 'Select range',
        expectedDeparture: 'Expected departure',
        unNumber: 'e.g. UN1203',
        hazardName: 'Dangerous goods name',
        customsCode: 'Customs code',
        productName: 'Product name',
        declareValue: 'Declared value',
        deadline: 'Deadline',
        remark: 'Enter remarks',
        remarkDisplay: 'Additional notes shown on forwarder quotation page',
        remarkInput: 'Enter remark',
        station: 'Select cargo station',
        country: 'Select country',
        province: 'Select province/state',
        city: 'Select city',
        district: 'District/county',
        street: 'Town/street',
        detailAddress: 'Building/floor/location',
        postalCode: 'Postal code',
        contactName: 'Contact name',
        contactPhone: 'Contact phone',
        phone: 'Phone',
        fbaCode: 'e.g. LAX9, ONT8',
        warehouseCode: 'Warehouse code',
        aiText: 'Paste text to recognize, e.g.:\nFrom PVG/Shanghai Pudong to LAX/Los Angeles\nAirline: CA\nCargo: 3 pcs, 150 KGS, 1.2 CBM\nCargo type: General\nIncoterm: DAP',
        chatInput: 'Type a message...',
        uldExample: 'e.g. AKE, PMC, PAG',
        quantity: 'Quantity',
        packageType: 'Select package type',
        handling: 'Forklift, crane, platform, etc.',
        handlingFull: 'Ground handling requirements such as forklift, crane, platform',
        temperature: 'Temperature',
        airflow: 'Airflow',
        humidity: 'Humidity',
        length: 'Length',
        width: 'Width',
        height: 'Height',
        pieces: 'Pieces',
        weight: 'Weight',
        volume: 'Volume',
        palletCount: 'Pallet count',
        uldType: 'Select ULD type',
        aircraftType: 'Select aircraft type',
        aircraftName: 'Enter aircraft type',
        autoCalc: 'Auto calculated',
        totalWeight: 'Total weight',
        totalVolume: 'Total volume',
        selectOrInput: 'Select or enter',
        selectOptional: 'Select (optional)',
        tempExample: 'e.g. -18'
      },
      options: {
        quoteSegment: {
          trunk: 'Trunk Price',
          prePort: 'Pre-port Price',
          lastMile: 'Last-mile Price'
        },
        inquirySource: {
          manual: 'Manual',
          customer: 'Customer',
          system: 'System'
        },
        inquiryStatus: {
          draft: 'Draft',
          submitted: 'Submitted',
          quoting: 'Quoting',
          completed: 'Completed',
          cancelled: 'Cancelled'
        },
        quoteTarget: {
          broker: 'Business',
          supplier: 'Supplier'
        },
        quoteStatus: {
          pending: 'Pending',
          quoted: 'Quoted',
          confirmed: 'Confirmed',
          na: 'N/A'
        },
        negotiationStatus: {
          none: 'None',
          negotiating: 'Negotiating',
          completed: 'Completed'
        },
        inquiryNature: {
          pricing: 'Pricing',
          formal: 'Formal Inquiry'
        },
        paymentTerm: {
          prepaid: 'Prepaid',
          collect: 'Collect',
          prepaidCollect: 'Prepaid & Collect'
        },
        transportTermAir: {
          aa: 'A-A (Airport-Airport)',
          da: 'D-A (Door-Airport)',
          ad: 'A-D (Airport-Door)',
          dd: 'D-D (Door-Door)'
        },
        directTransit: {
          any: 'Any',
          direct: 'Direct',
          transit: 'Transit'
        },
        cargoReadyType: {
          date: 'Specific Date',
          range: 'Date Range'
        },
        cargoType: {
          normal: 'General',
          dangerous: 'Dangerous',
          cold: 'Cold Chain',
          special: 'Special',
          live: 'Live'
        },
        hazardClass: {
          c1: 'Class 1 Explosives',
          c2: 'Class 2 Gases',
          c3: 'Class 3 Flammable Liquids',
          c4: 'Class 4 Flammable Solids',
          c5: 'Class 5 Oxidizing Substances',
          c6: 'Class 6 Toxic Substances',
          c7: 'Class 7 Radioactive Material',
          c8: 'Class 8 Corrosives',
          c9: 'Class 9 Miscellaneous'
        },
        packageType: {
          carton: 'Carton',
          wooden: 'Wooden',
          wooden_case: 'Wooden Case',
          wooden_box: 'Wooden Box',
          pallet: 'Pallet',
          bulk: 'Bulk',
          bag: 'Bag',
          woven_bag: 'Woven Bag',
          drum: 'Drum',
          roll: 'Roll',
          naked: 'Naked',
          other: 'Other',
          crate: 'Crate',
          bundle: 'Bundle'
        },
        deliveryAddressType: {
          amazon: 'Amazon Warehouse',
          yicang: 'YiCang',
          thirdParty: 'Third Party'
        },
        openClose: {
          open: 'Open',
          close: 'Close'
        },
        aircraft: {
          allCargo: 'All-cargo',
          passengerCargo: 'Passenger/Cargo (Belly)',
          custom: 'Custom Aircraft'
        },
        uldType: {
          P1P: 'P1P (Standard Air Pallet)',
          P6P: 'P6P (High Pallet)',
          PAJ: 'PAJ (Narrow Pallet)',
          PGA: 'PGA (Standard Pallet)',
          PAC: 'PAC (Structural Pallet)',
          AKE: 'AKE (LD-3 Container)',
          AKH: 'AKH (LD-3 High Container)',
          AVE: 'AVE (LD-6 Container)',
          AMA: 'AMA (M1 Container)'
        },
        serviceTypeForm: {
          consol: 'Consol/Bulk',
          bulk: 'Bulk',
          fullPallet: 'Full Pallet',
          pallet: 'Full Pallet',
          blockSpace: 'Block Space',
          charterSpace: 'Block Space',
          fullCharter: 'Full Charter'
        }
      },
      messages: {
        loadFailed: 'Failed to load air inquiry',
        saveDraftSuccess: 'Draft saved successfully',
        saveDraftFailed: 'Failed to save draft',
        publishSuccess: 'Air inquiry published',
        publishFailed: 'Failed to publish inquiry',
        submitSuccess: 'Air inquiry submitted',
        submitFailed: 'Failed to submit inquiry',
        resetSuccess: 'Form reset',
        emailSent: 'Inquiry email sent',
        emailNotAvailable: 'Inquiry email sending is not available yet',
        matchRatesComingSoon: 'Air rate matching coming soon',
        matchRatesSuccess: '{count} matched rates found',
        matchRatesFailed: 'Failed to query matched rates',
        aiComingSoon: 'AI recognition coming soon',
        requiredFieldsPrefix: 'Please complete required fields: ',
        selectServiceTypeFirst: 'Please select a service type first',
        allInPriceTip: 'Allow suppliers to quote an all-in one-price amount',
        totalSummary: 'Total: {pieces} pcs / {weight} KGS / {volume} CBM',
        densitySummary: 'Density: {density} KG/CBM',
        priceSegmentEnabled: 'Enable at least one of trunk, pre-port, or last-mile price',
        priceSegmentActive: 'Price segment enabled',
        deadlineFutureRequired: 'The quotation deadline must be later than the current time'
      },
      ai: {
        uploadTitle: 'Click or drag to upload inquiry files',
        uploadDesc: 'Supports JPG/PNG/PDF/Excel/Word',
        tip: 'If only inquiring pre-port and last-mile charges, mark 「Pre-port」 and 「Last-mile」 clearly before the related info.',
        recognizedCount: '{count} fields recognized',
        confirmLowConfidence: 'Please confirm'
      },
      matchRates: {
        title: 'Matched Rates',
        empty: 'No matched rates',
        valid: 'Valid',
        expiringSoon: 'Expiring Soon',
        unitPrice: 'Unit Price',
        minCharge: 'Min Charge',
        flight: 'Flight',
        pending: 'Pending',
        validity: 'Validity',
        route: 'Route'
      },
      agent: {
        title: 'Agent Inquiry',
        greeting: 'Hi! I can help you fill the air inquiry.<br />Which airports are origin and destination, and roughly how heavy is the cargo?',
        send: 'Send',
        switchToAi: 'Switch to AI Recognition',
        clearChat: 'Clear Chat'
      },
      detail: {
        title: 'Air Inquiry Detail',
        totalQuotes: '{count} quotations',
        sentSuppliersWithCount: 'Sent Suppliers ({count})',
        contact: 'Contact',
        quotedAt: 'Quoted At',
        sections: {
          inquiryInfo: 'Inquiry Info',
          quotationSummary: 'Quotation Summary'
        },
        columns: {
          supplier: 'Supplier',
          quotationNo: 'Quotation No.',
          serviceType: 'Service Type',
          flightNo: 'Flight No.',
          charges: 'Charges',
          validPeriod: 'Validity',
          submitDate: 'Submit Time',
          routeLevel: 'Route Level',
          flightDepartureTime: 'Departure Time',
          flightArrivalTime: 'Arrival Time',
          chargeName: 'Charge Item',
          unitRate: 'Unit Rate',
          amount: 'Amount',
          confirmStatus: 'Confirm Status',
          consultStatus: 'Consultation Status'
        },
        actions: {
          refresh: 'Refresh',
          confirmSupplier: 'Confirm Supplier',
          cancelConfirm: 'Cancel Confirm',
          negotiate: 'Negotiate'
        },
        status: {
          unconfirmed: 'Unconfirmed',
          confirmed: 'Confirmed',
          imported: 'Imported',
          quoted: 'Quoted',
          pending: 'Pending',
          notConsulted: 'Not Consulted',
          consulting: 'Consulting',
          consultCompleted: 'Completed'
        },
        help: {
          beforeConfirm: 'You can negotiate with suppliers before confirming.',
          afterConfirm: 'After confirming, you can cancel and select again.'
        },
        modal: {
          quotationDetail: 'Quotation Detail',
          charges: 'Charge Details',
          noCharges: 'No charges',
          initiateConsultation: 'Initiate Consultation',
          expectedPrice: 'Expected Price',
          expectedPricePlaceholder: 'Enter expected price',
          consultationNote: 'Consultation Note'
        },
        confirm: {
          cancelTitle: 'Cancel Confirm',
          cancelContent: 'Cancel the currently confirmed supplier?'
        },
        messages: {
          loadQuotationFailed: 'Failed to load air quotations',
          selectQuotationFirst: 'Please select a quotation first',
          confirmSuccess: 'Supplier confirmed',
          confirmFailed: 'Failed to confirm supplier',
          cancelConfirmSuccess: 'Confirmation cancelled',
          cancelConfirmFailed: 'Failed to cancel confirmation',
          consultSuccess: 'Consultation initiated',
          consultFailed: 'Failed to initiate consultation',
          consultUnavailable: 'Consultation unavailable for current quotation',
          expectedPriceRequired: 'Please enter expected price'
        }
      }
    },

    rail: {
      pageTitle: {
        create: 'New Rail Inquiry',
        edit: 'Edit Rail Inquiry',
        view: 'View Rail Inquiry',
        copy: 'Copy Rail Inquiry',
        tag: 'Rail'
      },
      sections: {
        basic: 'Basic Info',
        route: 'Route Info',
        cargo: 'Cargo Info',
        dangerous: 'Dangerous Goods',
        serviceType: 'Service Type',
        serviceBulk: 'Bulk Cargo Info',
        servicePallet: 'Full Pallet Info',
        serviceCharterSpace: 'Block Space Info',
        serviceFullCharter: 'Full Charter Info',
        containerGroup: 'Container Group',
        prePort: 'Pre-port Pickup Address',
        lastMile: 'Last-mile Delivery Address',
        requirement: 'Quotation Requirements',
        ai: 'AI Recognition',
        special: 'Special Requirements'
      },
      fields: {
        inquiryNature: 'Inquiry Nature',
        paymentTerm: 'Payment Term',
        serviceType: 'Service Type',
        routeType: 'Route Type',
        lineCategory: 'Line Category',
        serviceTerm: 'Service Term',
        transportTerm: 'Transport Term',
        cargoReadyTime: 'Cargo Ready Time',
        cargoReadyTimeType: 'Cargo Ready Type',
        cargoType: 'Cargo Type',
        hsCode: 'HSCODE',
        cargoValue: 'Cargo Value',
        onePriceSupported: 'All-in Price',
        onePriceSupportedTip: 'All-in price',
        quotationDeadline: 'Quote Deadline',
        quoteDeadline: 'Quote Deadline',
        needCustomsClearance: 'Customs Clearance',
        needInsurance: 'Insurance',
        carrier: 'Carrier',
        railwayCompany: 'Railway Company',
        createdBy: 'Created By',
        dateCreated: 'Created At',
        specialRequirements: 'Special Requirements',
        remarks: 'Remarks',
        loadingCountry: 'Origin Country',
        loadingCity: 'Origin City',
        loadingStation: 'Origin Station',
        destinationCountry: 'Destination Country',
        destinationCity: 'Destination City',
        destinationStation: 'Destination Station',
        originCountry: 'Origin Country',
        originCity: 'Origin City',
        originStation: 'Origin Station',
        destCountry: 'Destination Country',
        destCity: 'Destination City',
        destStation: 'Destination Station',
        containerType: 'Container Type',
        containerNum: 'Container Qty',
        quantity: 'Pieces',
        weight: 'Gross Weight',
        length: 'Length',
        width: 'Width',
        height: 'Height',
        inquiryNo: 'Inquiry No.',
        inquirySource: 'Inquiry Source',
        inquirer: 'Inquirer',
        inquiryStatus: 'Inquiry Status',
        quoteTarget: 'Quote Target',
        targetType: 'Target Type',
        clientName: 'Client',
        clientType: 'Client Type',
        clientTitle: 'Client Title',
        directTransit: 'Direct/Transit',
        unNumber: 'UN No.',
        hazardClass: 'Hazard Class',
        productName: 'Product Name',
        cargoValueCurrency: 'Currency',
        country: 'Country',
        province: 'Province/State',
        city: 'City',
        district: 'District/County',
        street: 'Town/Street',
        detailAddress: 'Detail Address',
        postalCode: 'Postal Code',
        contactName: 'Contact',
        contactPhone: 'Contact Phone',
        railStation: 'Origin Rail Cargo Station',
        destRailStation: 'Destination Rail Cargo Station',
        pieces: 'Pieces',
        grossWeight: 'Gross Weight(KGS)',
        volume: 'Volume(CBM)',
        packageType: 'Package Type',
        temperature: 'Temperature(℃)',
        ventilationDoor: 'Ventilation Door',
        airflow: 'Airflow(m³/h)',
        humidity: 'Humidity(%RH)',
        preCooling: 'Pre-cooling',
        truckType: 'Truck Type',
        vehicleCount: 'Vehicle Count',
        totalPieces: 'Total Pieces',
        totalWeight: 'Total Gross Weight(KGS)',
        totalVolume: 'Total Volume(CBM)'
      },
      actions: {
        matchRates: 'Match Rates',
        reset: 'Reset',
        saveDraft: 'Save Draft',
        publish: 'Publish',
        submit: 'Submit Inquiry',
        back: 'Back to List',
        recognize: 'Recognize',
        clear: 'Clear',
        uploadFile: 'Upload File',
        pasteText: 'Paste Text',
        recognizing: 'Recognizing...',
        addContainerGroup: 'Add Container Group',
        delete: 'Delete',
        send: 'Send',
        switchToAi: 'Switch to AI Recognition',
        clearChat: 'Clear Chat',
        confirm: 'Confirm'
      },
      placeholders: {
        input: 'Enter',
        select: 'Select',
        optional: 'Optional',
        autoGenerate: 'Auto generated',
        currentUser: 'Current logged-in user',
        autoInferTargetType: 'Auto-inferred from quote target',
        clientName: 'Client name',
        selectClientType: 'Select client type',
        selectClient: 'Select client',
        enterClientTitle: 'Enter client title',
        multiAirline: 'Optional, multi-select supported',
        searchAirport: 'Search by code',
        selectDate: 'Select date',
        selectRange: 'Select range',
        expectedDeparture: 'Expected departure',
        unNumber: 'e.g. UN1203',
        hazardName: 'Dangerous goods name',
        customsCode: 'Customs code',
        productName: 'Product name',
        declareValue: 'Declared value',
        deadline: 'Deadline',
        remark: 'Remarks',
        remarkDisplay: 'Additional notes shown on forwarder quotation page',
        remarkInput: 'Enter remark',
        station: 'Select cargo station',
        country: 'Select country',
        province: 'Select province/state',
        city: 'Select city',
        district: 'District/county',
        street: 'Town/street',
        detailAddress: 'Building/floor/location',
        postalCode: 'Postal code',
        contactName: 'Contact name',
        contactPhone: 'Contact phone',
        phone: 'Phone',
        fbaCode: 'e.g. LAX9, ONT8',
        warehouseCode: 'Warehouse code',
        aiText: 'Paste text to recognize, e.g.:\nFrom Shanghai Minhang to Duisburg\nRailway: CRCT\nLine: Central\nService: Container\nContainer: 40HC',
        chatInput: 'Type a message...',
        uldExample: 'e.g. AKE, PMC, PAG',
        quantity: 'Quantity',
        packageType: 'Select package type',
        handling: 'Forklift, crane, platform, etc.',
        handlingFull: 'Ground handling requirements such as forklift, crane, platform',
        temperature: 'Temperature',
        airflow: 'Airflow',
        humidity: 'Humidity',
        length: 'Length',
        width: 'Width',
        height: 'Height',
        pieces: 'Pieces',
        weight: 'Weight',
        volume: 'Volume',
        palletCount: 'Pallet count',
        uldType: 'Select ULD type',
        aircraftType: 'Select aircraft type',
        aircraftName: 'Enter aircraft type',
        autoCalc: 'Auto calculated',
        totalWeight: 'Total weight',
        totalVolume: 'Total volume',
        selectOrInput: 'Select or enter',
        selectOptional: 'Select (optional)',
        tempExample: 'e.g. -18'
      },
      options: {
        quoteSegment: {
          trunk: 'Trunk Price',
          prePort: 'Pre-port Price',
          lastMile: 'Last-mile Price'
        },
        inquirySource: {
          manual: 'Manual',
          customer: 'Customer',
          system: 'System'
        },
        inquiryStatus: {
          draft: 'Draft',
          submitted: 'Submitted',
          quoting: 'Quoting',
          completed: 'Completed',
          cancelled: 'Cancelled'
        },
        quoteTarget: {
          broker: 'Business',
          supplier: 'Supplier'
        },
        quoteStatus: {
          pending: 'Pending',
          quoted: 'Quoted',
          confirmed: 'Confirmed',
          na: 'N/A'
        },
        negotiationStatus: {
          none: 'None',
          negotiating: 'Negotiating',
          completed: 'Completed'
        },
        inquiryNature: {
          pricing: 'Pricing',
          formal: 'Formal Inquiry'
        },
        paymentTerm: {
          prepaid: 'Prepaid',
          collect: 'Collect',
          prepaidCollect: 'Prepaid & Collect'
        },
        transportTermRail: {
          cycy: 'CY-CY (Station-Station)',
          doordoor: 'DOOR-DOOR (Door-Door)',
          cydoor: 'CY-DOOR (Station-Door)',
          doorcy: 'DOOR-CY (Door-Station)'
        },
        directTransit: {
          any: 'Any',
          direct: 'Direct',
          transit: 'Transit'
        },
        cargoReadyType: {
          date: 'Specific Date',
          range: 'Date Range'
        },
        cargoType: {
          normal: 'General',
          dangerous: 'Dangerous',
          cold: 'Cold Chain',
          special: 'Special',
          live: 'Live'
        },
        hazardClass: {
          c1: 'Class 1 Explosives',
          c2: 'Class 2 Gases',
          c3: 'Class 3 Flammable Liquids',
          c4: 'Class 4 Flammable Solids',
          c5: 'Class 5 Oxidizing Substances',
          c6: 'Class 6 Toxic Substances',
          c7: 'Class 7 Radioactive Material',
          c8: 'Class 8 Corrosives',
          c9: 'Class 9 Miscellaneous'
        },
        packageType: {
          carton: 'Carton',
          wooden: 'Wooden',
          wooden_case: 'Wooden Case',
          wooden_box: 'Wooden Box',
          pallet: 'Pallet',
          bulk: 'Bulk',
          bag: 'Bag',
          woven_bag: 'Woven Bag',
          drum: 'Drum',
          roll: 'Roll',
          naked: 'Naked',
          other: 'Other',
          crate: 'Crate',
          bundle: 'Bundle'
        },
        deliveryAddressType: {
          amazon: 'Amazon Warehouse',
          yicang: 'YiCang',
          thirdParty: 'Third Party'
        },
        openClose: {
          open: 'Open',
          close: 'Close'
        },
        truckType: {
          boxcar: 'Boxcar',
          flatcar: 'Flatcar',
          openCar: 'Open Car',
          boxcarHc: 'High-side Boxcar'
        },
        vehicleType: {
          openCar: 'Open Car',
          boxcar: 'Boxcar',
          flatcar: 'Flatcar',
          reefer: 'Reefer Car',
          ore: 'Ore Car',
          cement: 'Cement Car'
        },
        railServiceTypeForm: {
          container: 'Container',
          fullLoad: 'Full Load',
          bulk: 'Bulk'
        },
        lineCategory: {
          central: 'Central',
          north: 'North',
          south: 'South',
          southeastAsia: 'Southeast Asia',
          centralAsia: 'Central Asia'
        },
        railwayCompany: {
          CRCT: 'CRCT',
          CRP: 'CRP',
          KR: 'KTZ (Kazakhstan)',
          RZD: 'RZD (Russia)',
          UTLC: 'UTLC Eurasia',
          PKP: 'PKP (Poland)',
          other: 'Other (please specify)',
          separator: '━━ Tenant Custom ━━'
        },
        containerType: {
          '20GP': '20GP',
          '40GP': '40GP',
          '40HC': '40HC High Cube',
          '45HC': '45HC High Cube',
          '20RF': '20RF Reefer',
          '40RH': '40RH Reefer',
          '20TK': '20TK Tank',
          '20OT': '20OT Open Top'
        }
      },
      messages: {
        loadFailed: 'Failed to load rail inquiry',
        saveDraftSuccess: 'Draft saved successfully',
        saveDraftFailed: 'Failed to save draft',
        publishSuccess: 'Rail inquiry published',
        publishFailed: 'Failed to publish inquiry',
        submitSuccess: 'Rail inquiry submitted',
        submitFailed: 'Failed to submit inquiry',
        resetSuccess: 'Form reset',
        emailSent: 'Inquiry email sent',
        emailNotImplemented: 'Inquiry email sending not yet available',
        matchRatesComingSoon: 'Rail rate matching coming soon',
        aiComingSoon: 'AI recognition coming soon',
        requiredFieldsPrefix: 'Please complete required fields: ',
        selectServiceTypeFirst: 'Please select a service type first',
        allInPriceTip: 'Allow suppliers to quote an all-in one-price amount',
        totalSummary: 'Total: {pieces} pcs / {weight} KGS / {volume} CBM',
        densitySummary: 'Density: {density} KG/CBM',
        priceSegmentEnabled: 'Enable at least one of trunk, pre-port, or last-mile price',
        priceSegmentActive: 'Price segment enabled',
        containerGroupLabel: 'Container Group {index}',
        containerTotalSummary: 'Total: {pieces} pcs / {weight} KGS',
        fullLoadSummary: '{vehicles} vehicles / {pieces} pcs / {weight} KGS',
        bulkTotalSummary: 'Total: {pieces} pcs / {weight} KGS',
        switchServiceTypeConfirm: 'Switching service type will clear filled cargo info. Continue?',
        deadlineFutureRequired: 'The quotation deadline must be later than the current time'
      },
      ai: {
        uploadTitle: 'Click or drag to upload inquiry files',
        uploadDesc: 'Supports JPG/PNG/PDF/Excel/Word',
        tip: 'If only inquiring pre-port and last-mile charges, mark 「Pre-port」 and 「Last-mile」 clearly before the related info.',
        recognizedCount: '{count} fields recognized',
        confirmLowConfidence: 'Please confirm'
      },
      matchRates: {
        title: 'Matched Rates',
        empty: 'No matched rates',
        valid: 'Valid',
        expiringSoon: 'Expiring Soon',
        unitPrice: 'Unit Price',
        minCharge: 'Min Charge',
        flight: 'Train No.',
        pending: 'Pending',
        validity: 'Validity',
        route: 'Line'
      },
      confirm: {
        switchServiceTypeTitle: 'Switch Service Type',
        switchServiceTypeContent: 'Switching service type will clear filled cargo info. Continue?'
      },
      agent: {
        title: 'Agent Inquiry',
        greeting: 'Hi! I can help you fill the rail inquiry.<br />Which countries are origin and destination, and which railway company?',
        send: 'Send',
        switchToAi: 'Switch to AI Recognition',
        clearChat: 'Clear Chat'
      },
      detail: {
        title: 'Rail Inquiry Detail',
        totalQuotes: '{count} quotations',
        sentSuppliersWithCount: 'Sent Suppliers ({count})',
        contact: 'Contact',
        quotedAt: 'Quoted At',
        sections: {
          inquiryInfo: 'Inquiry Info',
          quotationSummary: 'Quotation Summary'
        },
        columns: {
          supplier: 'Supplier',
          quotationNo: 'Quotation No.',
          serviceType: 'Service Type',
          routeType: 'Route Type',
          charges: 'Charges',
          validPeriod: 'Validity',
          submitDate: 'Submit Time',
          trainDepartureTime: 'Departure Time',
          trainArrivalTime: 'Arrival Time',
          borderCrossTime: 'Border Crossing',
          demurrageFreeDays: 'Free Storage Days',
          overweightRemarks: 'Weight Limit',
          chargeName: 'Charge Item',
          unitRate: 'Unit Rate',
          amount: 'Amount',
          confirmStatus: 'Confirm Status',
          consultStatus: 'Consultation Status'
        },
        actions: {
          refresh: 'Refresh',
          confirmSupplier: 'Confirm Supplier',
          cancelConfirm: 'Cancel Confirm',
          negotiate: 'Negotiate'
        },
        status: {
          unconfirmed: 'Unconfirmed',
          confirmed: 'Confirmed',
          imported: 'Imported',
          quoted: 'Quoted',
          pending: 'Pending',
          notConsulted: 'Not Consulted',
          consulting: 'Consulting',
          consultCompleted: 'Completed'
        },
        help: {
          beforeConfirm: 'You can negotiate with suppliers before confirming.',
          afterConfirm: 'After confirming, you can cancel and select again.'
        },
        modal: {
          quotationDetail: 'Quotation Detail',
          charges: 'Charge Details',
          noCharges: 'No charges',
          initiateConsultation: 'Initiate Consultation',
          expectedPrice: 'Expected Price',
          expectedPricePlaceholder: 'Enter expected price',
          consultationNote: 'Consultation Note'
        },
        confirm: {
          cancelTitle: 'Cancel Confirm',
          cancelContent: 'Cancel the currently confirmed supplier?'
        },
        messages: {
          loadQuotationFailed: 'Failed to load rail quotations',
          selectQuotationFirst: 'Please select a quotation first',
          confirmSuccess: 'Supplier confirmed',
          confirmFailed: 'Failed to confirm supplier',
          cancelConfirmSuccess: 'Confirmation cancelled',
          cancelConfirmFailed: 'Failed to cancel confirmation',
          consultSuccess: 'Consultation initiated',
          consultFailed: 'Failed to initiate consultation',
          consultUnavailable: 'Consultation unavailable for current quotation',
          expectedPriceRequired: 'Please enter expected price'
        }
      }
    },

    // Action buttons
    actions: {
      view: 'View',
      detail: 'Details',
      edit: 'Edit',
      submit: 'Submit',
      revoke: 'Revoke',
      delete: 'Delete',
      more: 'More',
      copy: 'Copy',
      confirmSupplier: 'Confirm Supplier',
      cancelConfirmSupplier: 'Cancel Confirm Supplier'
    },

    // Status display
    status: {
      pending: 'Pending',
      quoted: 'Quoted',
      notEnabled: 'Not Enabled',
      rejected: 'Rejected',
      notQuoted: 'Not Quoted',
      notConsulted: 'Not Consulted',
      consulting: 'Consulting',
      consultationCompleted: 'Consultation Completed'
    },

    // Confirmation dialogs
    confirmDialog: {
      submitTitle: 'Confirm Submit',
      submitContent: 'Are you sure to submit inquiry "{inquiryNo}"?',
      submitOk: 'Confirm Submit',
      submitCancel: 'Cancel',
      revokeTitle: 'Confirm Revoke',
      revokeContent: 'Are you sure to revoke inquiry "{inquiryNo}" to draft status?',
      revokeOk: 'Confirm Revoke',
      revokeCancel: 'Cancel',
      deleteTitle: 'Confirm Delete',
      deleteContent: 'Are you sure to delete inquiry "{inquiryNo}"?',
      batchDeleteTitle: 'Batch Delete Confirmation',
      batchDeleteContent: 'Are you sure to delete the selected {count} records?'
    },

    // Copy confirmation dialog
    copyConfirm: {
      title: 'Confirm Copy Inquiry',
      description: 'Are you sure you want to copy this inquiry? A new draft inquiry will be created after copying.',
      detailTitle: 'Inquiry Details',
      inquiryNo: 'Inquiry No.'
    },

    // View template
    viewTemplate: {
      noTemplateTitle: 'View template not configured',
      noTemplateSubtitle: 'No published inquiry view template for this business type. Create and publish one in platform admin first.'
    },

    // Messages
    messages: {
      dataLoadFailed: 'Failed to load inquiry data',
      selectRecordsFirst: 'Please select records to delete first',
      noDataToExport: 'No data to export',
      exportSuccess: 'Successfully exported {count} records as {type} format',
      exportFailed: 'Failed to export {type} format, please try again later',
      submitSuccess: 'Inquiry submitted successfully',
      submitFailed: 'Submit failed, please try again later',
      revokeSuccess: 'Inquiry has been revoked to draft status',
      revokeFailed: 'Revoke failed, please try again later',
      deleteSuccess: 'Delete successful',
      deleteFailed: 'Delete failed',
      copySuccess: 'Copy successful',
      copyFailed: 'Copy failed, please try again later',
      batchDeleteSuccess: 'Batch delete successful',
      batchDeleteFailed: 'Batch delete failed',
      alreadyDraft: 'Inquiry is already in draft status, no need to revoke',
      onlySubmittedCanRevoke: 'Only submitted inquiries can be revoked to draft',
      invalidStatusForAction: 'Invalid inquiry status',
      cannotDeleteRecords: 'Submitted inquiries cannot be deleted, please check the selected records'
    },

    // Unread notifications
    notifications: {
      title: 'Notifications',
      prePortQuoted: 'First-leg quoted',
      trunkLineQuoted: 'Main-leg quoted',
      lastMileQuoted: 'Last-mile quoted',
      allQuoted: 'All quotations completed'
    },

    // Custom table modal
    customTableModal: {
      title: 'Custom Table Fields',
      description: 'Select fields to display in the table',
      resetButton: 'Reset'
    },

    // Export
    export: {
      filename: 'Inquiry Data'
    },
    // Detail configuration
    detail: {
      assignType: 'Assignment Target'
    },
    filterPlaceholders: {
      enterInquiryNo: 'Please enter inquiry number',
      selectSource: 'Please select inquiry source',
      selectInquirer: 'Please select inquirer',
      selectStatus: 'Please select inquiry status',
      selectCarrier: 'Please select carrier',
      selectTrunkLineStatus: 'Please select trunk line quote status',
      selectPrePortStatus: 'Please select pre-port quote status',
      selectLastMileStatus: 'Please select last mile quote status',
      selectCargoReadyTimeType: 'Please select cargo ready time type',
      selectCargoReadyTimeRange: 'Please select cargo ready time range',
      selectCargoReadyTimeDate: 'Please select cargo ready time',
      selectPalletNature: 'Please select pallet nature',
      selectDirectTransit: 'Please select direct/transit',
      selectRoute: 'Please select route',
      selectPol: 'Please select port of loading',
      selectPod: 'Please select port of discharge',
      selectDischargingPort: 'Please select port of discharge',
      selectCargoType: 'Please select cargo type',
      selectServiceTerm: 'Please select service terms',
      enterCustomServiceTerm: 'Please enter custom service terms',
      selectClientType: 'Please select client type',
      enterClientTitle: 'Please enter client name',
      enterSeaEq: 'Please enter container info',
      enterRemarks: 'Please enter remarks',
      selectDateCreated: 'Please select creation time range',
      selectDateModified: 'Please select modification time range',
      selectCreatedBy: 'Please select created by',
      selectModifiedBy: 'Please select modified by'
    }
  },

  // Inquiry Detail Page
  inquiryDetail: {
    // Page titles
    pageTitle: {
      create: 'New Inquiry',
      edit: 'Inquiry Detail',
      view: 'Inquiry Detail',
      loading: 'Loading...'
    },

    // Form sections
    sections: {
      basicInfo: 'Basic Information',
      cargoInfo: 'Cargo Information',
      loadingPoint: 'Loading Point',
      deliveryAddress: 'Last Mile Delivery Address',
      containerInfo: 'Container Type & Quantity',
      matchPrice: 'Matched Prices',
      fclPrice: 'FCL Prices',
      prePortPrice: 'Preport Prices',
      lastMilePrice: 'Last Mile Prices',
      supplierQuotation: 'Supplier Quotations'
    },

    // View-template service-cargo section
    viewCargo: {
      sectionTitle: 'Cargo Info',
      empty: 'No cargo data',
      noColumns: 'No display columns configured for this service type',
      yes: 'Yes',
      no: 'No',
      ventilationOpen: 'Open',
      ventilationClose: 'Close',
      ventilationOpenWithQty: 'Open {qty} CBM/H',
      serviceTypes: {
        FCL: 'FCL',
        LCL: 'LCL',
        RORO: 'RoRo',
        BULK: 'Bulk',
        bulk: 'Bulk',
        pallet: 'Pallet',
        charterSpace: 'Charter Space',
        fullCharter: 'Full Charter',
        container: 'Container',
        fullLoad: 'Full Load',
        default: 'Cargo'
      },
      transportCategory: {
        '1': 'Vehicles',
        '2': 'Wheeled/Tracked Equipment',
        '3': 'RoRo Pallet/Unit Cargo',
        '4': 'Oversized with Wheels',
        vehicle: 'Vehicles',
        equipment: 'Wheeled/Tracked Equipment',
        roro_pallet: 'RoRo Pallet/Unit Cargo',
        oversized: 'Oversized with Wheels'
      },
      columns: {
        containerType: 'Container Type',
        containerNum: 'Container Qty',
        piecesPerContainer: 'Pieces/Container',
        weightPerContainer: 'Gross Weight(KGS)/Container',
        dimensions: 'Dimensions',
        temperatureRange: 'Temperature',
        ventilation: 'Ventilation',
        humidity: 'Humidity',
        needPrecooling: 'Pre-cooling',
        pieces: 'Pieces',
        weightPerPiece: 'Gross Weight(KGS)/Piece',
        lengthM: 'Length(M)',
        widthM: 'Width(M)',
        heightM: 'Height(M)',
        packageType: 'Package Type',
        totalVolume: 'Total Volume',
        transportCategory: 'Transport Category',
        vehicleType: 'Vehicle Type',
        vehicleBrand: 'Vehicle Brand',
        vehicleModel: 'Vehicle Model',
        equipmentName: 'Equipment Name',
        isCrawler: 'Crawler',
        isSelfPropelled: 'Self-propelled',
        quantity: 'Quantity',
        outerLengthM: 'Outer Length(M)',
        outerWidthM: 'Outer Width(M)',
        outerHeightM: 'Outer Height(M)',
        weightKgs: 'Gross Weight(KGS)',
        isOversized: 'Oversized',
        canDeckLoad: 'Deck Load',
        specialFixingRequirement: 'Special Fixing',
        cargoName: 'Cargo Name',
        package: 'Package',
        stowageFactor: 'Stowage Factor',
        liftingRequirement: 'Lifting Requirement',
        lengthCm: 'Length(CM)',
        widthCm: 'Width(CM)',
        heightCm: 'Height(CM)',
        remark: 'Remark',
        palletType: 'Pallet Type',
        palletNum: 'Pallet Qty',
        volumeCbm: 'Volume(CBM)',
        truckType: 'Truck Type'
      }
    },

    // Checkbox options
    checkboxes: {
      prePortPrice: 'Preport Price',
      trunkLinePrice: 'Trunk Line Price',
      lastMilePrice: 'Last Mile Price'
    },

    // Attachments
    attachments: {
      title: 'Attachments',
      titleRequired: 'Attachments *',
      tip: 'Supports uploading documents, images, compressed files, etc. Max 20MB per file, up to 20 files.'
    },

    // Action buttons
    actions: {
      saveDraft: 'Save Draft',
      exportRate: 'Export Rate',
      exportQuotation: 'Export Quotation',
      submit: 'Submit',
      cancel: 'Cancel',
      back: 'Back',
      aiRecognition: 'AI Recognition',
      add: 'Add',
      matchPrice: 'Query Matched Prices',
      addContainerType: 'Add Container Type'
    },

    // Basic information fields
    basicInfo: {
      inquiryNo: 'Inquiry No.',
      inquirerId: 'Inquirer',
      palletNature: 'Pallet Nature',
      cargoReadyTime: 'Cargo Ready Time',
      palletQuality: 'Pallet Quality',
      serviceTerm: 'Service Term',
      client: 'Client',
      directTransit: 'Transport Mode',
      detailAddress: 'Detail Address'
    },

    // Cargo information fields
    cargoInfo: {
      directTransit: 'Direct/Transit',
      route: 'Route',
      loadingPort: 'Loading Port',
      destinationPort: 'Port of Discharge (POD)',
      dischargingPort: 'Discharging Port',
      transitPort1: 'Transit Port (1st)',
      transitPort2: 'Transit Port (2nd)',
      transitPort3: 'Transit Port (3rd)',
      cargoType: 'Cargo Type',
      hazardClass: 'Hazard Class',
      unNo: 'UN No.',
      temperature: 'Temperature',
      ventilation: 'Ventilation',
      quantity: 'Quantity',
      cargoQuantity: 'Cargo Quantity',
      weight: 'Weight',
      weightUnit: 'Weight Unit',
      dimensions: 'Dimensions',
      dimensionsUnit: 'Dimensions Unit',
      length: 'Length',
      width: 'Width',
      height: 'Height',
      cargoDescription: 'Cargo Description (HS Code)',
      containerRequirement: 'Container Requirement',
      transportTerms: 'Transport Terms',
      cargoValue: 'Cargo Value',
      cargoValueCurrency: 'Currency',
      carrier: 'Carrier',
      remarks: 'Remarks'
    },

    // Loading point fields
    loadingPoint: {
      selectArea: 'Select Loading Point Area',
      postalCode: 'Postal Code',
      stuffingTerminal: 'Stuffing Terminal/Yard',
      stuffingTerminalPlaceholder: 'Please select terminal/yard',
      deliveryTerminal: 'Delivery Terminal/Yard',
      deliveryTerminalPlaceholder: 'Please select terminal/yard',
      country: 'Country',
      province: 'Province/State',
      city: 'City',
      district: 'District/County',
      street: 'Street/Town',
      community: 'Community',
      stuffingSection: 'Pre-port Stuffing Point',
      stuffingCountry: 'Country',
      stuffingProvince: 'Province/State',
      stuffingCity: 'City',
      stuffingDistrict: 'District/County',
      stuffingStreet: 'Township/Town/Street',
      stuffingCommunity: 'Community',
      detailAddress: 'Detail Address',
      assignType: 'Assign Target'
    },

    // Delivery address fields
    deliveryAddress: {
      addressInfo: 'Delivery Address Information',
      addressType: 'Delivery Address Type',
      postalCodeAndCountry: 'Postal Code & Country',
      country: 'Select country',
      postalCode: 'Enter or select postal code',
      provinceCity: 'Province/State/City',
      province: 'Province/State',
      city: 'City',
      district: 'District',
      detailAddress: 'Detail Address',
      amazonWarehouse: 'Amazon Warehouse Selection',
      ecangWarehouse: 'Ecang Warehouse Selection'
    },

    // Container information fields
    containerInfo: {
      containerType: 'Container Type',
      quantity: 'Quantity',
      containerTypeAndQuantity: 'Container Type & Quantity: ',
      rfTemperatureRequirement: 'Temperature Requirement',
      rfVentilationRequirement: 'Ventilation Requirement',
      temperatureRange: 'Enter temperature range, e.g.: -20 to 30',
      temperatureStart: 'Start Temperature',
      temperatureEnd: 'End Temperature',
      ventilationDoor: 'Ventilation Door',
      ventilationOpen: 'Open',
      ventilationClose: 'Close',
      ventilationVolume: 'Air Flow',
      ventilationVolumeUnit: 'CBM/H',
      ventilationVolumePlaceholder: 'Enter air flow',
      humidity: 'Humidity',
      humidityPlaceholder: 'Please enter humidity',
      humidityUnit: '%RH',
      needPrecooling: 'Need Pre-cooling',
      needPrecoolingYes: 'Yes',
      needPrecoolingNo: 'No',
      temperatureTo: 'to',
      cargoQuantity: 'Quantity',
      pieces: 'Pieces',
      weight: 'Weight',
      weightUnit: 'Weight Unit',
      dimensions: 'Dimensions',
      dimensionsUnit: 'Dimensions Unit',
      length: 'Length',
      width: 'Width',
      height: 'Height',
      temperatureUnit: '℃'
    },

    // Placeholder texts
    placeholders: {
      autoGenerate: 'Auto Generate',
      selectPalletNature: 'Select pallet nature',
      selectCargoReadyTimeRange: 'Select cargo ready time range',
      selectCargoReadyDate: 'Select cargo ready date',
      selectOption: 'Please select',
      inputServiceTerm: 'Enter service term',
      selectClientType: 'Select client type',
      selectClient: 'Select client',
      inputClientTitle: 'Enter client title',
      selectRoute: 'Select route',
      selectLoadingPort: 'Select loading port',
      selectDestinationPort: 'Select port of discharge',
      selectDischargePort: 'Select discharge port',
      selectTransitPort1: 'Select first transit port',
      selectTransitPort2: 'Select second transit port',
      selectTransitPort3: 'Select third transit port',
      selectHazardClass: 'Select hazard class',
      inputUnNo: 'Enter UN No.',
      inputTemperature: 'Enter temperature',
      inputVentilation: 'Enter ventilation',
      enterInputQuantity: 'Enter quantity',
      inputWeight: 'Enter weight',
      inputDimensions: 'Enter dimensions',
      inputCargoDescription: 'Enter cargo description or HS Code',
      selectContainerRequirement: 'Select container requirement',
      selectTransportTerms: 'Select transport terms',
      inputCargoValue: 'Enter cargo value',
      selectCargoValueCurrency: 'Select currency',
      selectCarrier: 'Select carrier',
      inputRemarks: 'Enter remarks',
      province: 'Province',
      city: 'City',
      district: 'District',
      street: 'Street/Town',
      inputDetailAddress: 'Enter detail address',
      selectCountry: 'Select country',
      inputPostalCode: 'Enter or select postal code',
      inputDeliveryAddress: 'Enter detail address',
      selectAmazonWarehouse: 'Select Amazon warehouse',
      selectEcangWarehouse: 'Select Ecang warehouse',
      selectContainerType: 'Select container type',
      inputQuantity: 'Quantity',
      inputLoadingPointAddress: 'Enter loading point address',
      inputDeliveryAddressText: 'Enter delivery address',
      clickMatchPrice: 'Please click the "Query Matched Prices" button to get the price information',
      noFclMatches: 'No matching FCL prices found',
      noPrePortMatches: 'No matching preport prices found',
      noLastMileMatches: 'No matching last mile prices found',
      noFclPrices: 'No FCL prices',
      noPrePortPrices: 'No Preport prices',
      noLastMilePrices: 'No Last mile prices',
      quotePending: 'Quote pending',
      quoteRejected: 'Quote rejected',
      noFeeDetail: 'No fee detail',
      quotationStatus: 'Quotation Status',
      supplier: 'Supplier',
      allStatus: 'All Status',
      allSuppliers: 'All Suppliers',
      quoted: 'Quoted',
      imported: 'Imported',
      confirmed: 'Confirmed'
    },

    // Units and suffixes
    units: {
      celsius: '°C',
      kilogram: 'KGS'
    },

    // AI recognition modal
    aiModal: {
      loadingPointTitle: 'AI Smart Address Recognition',
      deliveryTitle: 'AI Smart Address Recognition',
      loadingPointDesc: 'Please paste the address information into the text box below:',
      deliveryDesc: 'Please paste the US address information into the text box below:',
      loadingPointTip: 'Tip: The system will automatically parse province, city, district and street information, detail address will be filled into the detail address field',
      deliveryRules: 'Recognition Rules:',
      deliveryRule1: 'If contains Amazon warehouse code (ONT8/BFI4 etc.), will be set as Amazon warehouse type',
      deliveryRule2: 'If contains Ecang code (LAX203/ATL205 etc.), will be set as Ecang type',
      deliveryRule3: 'Other cases will be set as third-party address, and parse address and postal code',
      recognize: 'Recognize',
      cancel: 'Cancel'
    },

    // Dropdown options
    options: {
      alibaba: 'Alibaba Group',
      jd: 'JD Logistics Co., Ltd.',
      huawei: 'Huawei Technologies Co., Ltd.',
      xiaomi: 'Xiaomi Corporation',
      haier: 'Haier Group Corporation',
      baosteel: 'Baosteel Group Corporation Limited',
      cmg: 'China Merchants Group',
      cosco: 'COSCO SHIPPING Holdings'
    },

    // Messages
    messages: {
      saveDraftSuccess: 'Draft saved successfully',
      updateSuccess: 'Inquiry updated successfully',
      submitSuccess: 'Inquiry submitted successfully',
      saveFailed: 'Save failed',
      submitFailed: 'Submit failed',
      loadFailed: 'Failed to load inquiry details',
      exportPending: 'Export rate function under development...',
      addressRecognitionSuccess: 'Address recognition successful',
      inputAddressFirst: 'Please enter address information',
      confirmSubmit: 'Confirm to submit inquiry?',
      confirm: 'Confirm',
      cancel: 'Cancel',
      loading: 'Loading...',
      noData: 'No data',
      copySuccess: 'Text copied to clipboard',
      copyFailed: 'Copy failed, please copy manually',
      noAvailablePrices: 'No available price information found. Please query and select matched prices, or wait for new quotations.',
      selectQuotedPriceFirst: 'Please select a quoted price first',
      loadTemplateFailed: 'Failed to load template',
      openTemplateViewReportFailed: 'Failed to open template view report',
      inquiryAllDisabled: 'At least one of trunk line, pre-port and last mile prices must be enabled',
      doorPostalCodeRequired: 'Postal code is required when transport terms end with DOOR',
      doorDeliveryAddressRequired: 'Delivery detail address is required when transport terms end with DOOR',
      routeMatchSuccess: 'Route matched successfully',
      routeMatchFailed: 'No matching route found',
      addressRecognitionFailed: 'Address recognition failed',
      cargoDescriptionRequired: 'Cargo description is required when transport terms end with DOOR',
      cargoValueRequired: 'Cargo value is required when service term is DDP or transport terms end with DOOR',
      cargoValueCurrencyRequired: 'Cargo value currency is required when service term is DDP or transport terms end with DOOR',
      rfTemperatureStartRequired: 'Start temperature is required',
      rfTemperatureEndRequired: 'End temperature is required',
      rfVentilationEnableRequired: 'Ventilation door is required',
      rfVentilationQuantityRequired: 'Air flow is required',
      loadingPortSameAsDestination: 'The port of loading and port of discharge cannot be the same',
      destinationPortSameAsLoading: 'The port of discharge and port of loading cannot be the same',
      confirmSupplierSuccess: 'Supplier confirmed successfully',
      confirmSupplierFailed: 'Failed to confirm supplier, please try again',
      confirmSupplierBlockedByConsulting: 'Cannot confirm supplier while negotiation is in progress',
      cancelConfirmSupplierSuccess: 'Supplier confirmation cancelled',
      cancelConfirmSupplierFailed: 'Failed to cancel supplier confirmation, please try again',
      selectQuotationFirst: 'Please select a quotation',
      resetFailed: 'Reset failed, please try again',
      fillRequiredFields: 'Please fill in the required fields',
      orderAlreadyCreated: 'Order created',
      orderNoPrefix: 'Order No.: ',
      orderIndexPrefix: 'Order {index}: ',
      orderAlreadyGenerated: 'This inquiry has generated orders and cannot be booked again',
      quotationNotExist: 'Quotation not found, cannot proceed to booking',
      supplierFallback: 'Supplier'
    },

    // Export quotation modal
    exportQuotationModal: {
      title: 'Export Quotations',
      containerTypeAndQuantity: 'Container Type & Quantity',
      copyQuotationText: 'Copy Quick Quotation Text',
      printQuotation: 'Print Quotation Document',
      printPending: 'Print function under development'
    },

    // Quick quotation text modal
    quotationTextModal: {
      title: 'Quick Quotation Text',
      description: 'The following is the quotation text generated based on your selected container types and quantities. You can copy and send it to customers:',
      placeholder: 'Please enter quotation text',
      close: 'Close',
      copyText: 'Copy Text'
    },

    // Quotation text content
    quotationText: {
      title: '【Inquiry Quotations】',
      inquiryNo: 'Inquiry No.: ',
      inquiryType: 'Inquiry Type: ',
      fcl: 'FCL',
      prePort: 'Pre port',
      lastMile: 'Last mile',
      inquirer: 'Inquirer: ',
      submitDate: 'Submit Date: ',
      containerTypeAndQuantity: 'Container Type & Quantity: ',
      routeInfo: 'Route Information: ',
      loadingPort: 'Port of Loading: ',
      destinationPort: 'Port of Discharge (POD): ',
      carrier: 'Carrier: ',
      directTransit: 'Direct/Transit: ',
      priceDetails: 'Price Details: ',
      trunkLineFee: 'Trunk Line Fee: ',
      prePortFee: 'Pre-port Fee: ',
      lastMileFee: 'Last Mile Fee: ',
      feeCalculation: 'Fee Calculation: ',
      trunkLine: 'Trunk Line: ',
      cargoReadyTime: 'Cargo Ready Time: ',
      client: 'Client: ',
      remarks: 'Remarks: ',
      priceDisclaimer: '※ The above prices are for reference only, actual prices are subject to formal contracts',
      contactInfo: '※ If you have any questions, please contact our customer service team',
      notSpecified: 'Not Specified',
      containerCharges: 'Container Charges: ',
      otherCharges: 'Other Charges: ',
      totalQuotes: 'Total {count} quotes',
      selectedQuotation: 'Selected Quotation: ',
      syncNotice: 'Base ocean freight will be written to rate maintenance; surcharges will be synced to surcharge management',
      oceanFreightCost: 'Base Ocean Freight (Cost)',
      oceanSurchargesCost: 'Ocean Surcharges',
      originPortFee: 'Origin Charges',
      destinationPortFee: 'Destination Charges',
      unitBox: 'Container',
      unitTicket: 'Ticket',
      selectedForImport: '{count} selected for import'
    },

    // Price display labels
    priceDisplay: {
      priceNo: 'Price No',
      carrierName: 'Carrier',
      validPeriod: 'Valid Period',
      directTransit: 'Direct/Transit',
      direct: 'Direct',
      transit: 'Transit',
      voyageDays: 'Voyage Days',
      days: 'day(s)',
      detentionFreeDays: 'Free Detention Days',
      demurrageFreeDays: 'Free Demurrage Days',
      containerCharges: 'Container Charges',
      otherCharges: 'Other Charges',
      supplier: 'Supplier',
      priceMethod: 'Price Method',
      agentName: 'Agent Name',
      basicSeaFee: 'Basic Ocean Freight',
      surcharge: 'Surcharge'
    },

    // ZIP code related
    zipCode: {
      loading: 'Loading...',
      loadProvincesFailed: 'Failed to load provinces',
      loadCitiesFailed: 'Failed to load cities',
      loadDistrictsFailed: 'Failed to load districts',
      loadStreetsFailed: 'Failed to load streets',
      loadZipCodesFailed: 'Failed to load postal codes',
      zipCodeQueryFailed: 'Postal code query failed',
      zipCodeLoadSuccess: 'China postal codes loaded successfully',
      loadContainerTypesFailed: 'Failed to load container types',
      containerTypesLoadSuccess: 'Container types loaded successfully'
    },

    // Table columns
    columns: {
      feeName: 'Fee Name',
      currency: 'Currency',
      unitRate: 'Unit Rate',
      measure: 'Measure',
      remarks: 'Remarks'
    },

    validation: {
      entrustingUnitRequired: 'Please select an entrusting unit',
      salesBranchRequired: 'Please select a sales branch'
    },

    unifiedCreate: {
      businessType: {
        fcl: 'FCL Inquiry',
        lcl: 'LCL Inquiry',
        air: 'Air Freight Inquiry',
        express: 'Express Inquiry',
        rail: 'Rail Inquiry',
        prePort: 'Pre-port Inquiry',
        lastMile: 'Last-mile Inquiry'
      },
      actions: {
        reset: 'Reset'
      },
      sections: {
        businessInfo: '{business} Information'
      },
      template: {
        loaded: 'Template loaded',
        noPublished: 'No published template',
        noPublishedAlert: 'No published form template is available for the current inquiry type. Please publish an inquiry template in the platform console first.',
        loadFirst: 'Please load an inquiry form template first'
      },
      priceDisplay: {
        agent: 'Agent',
        supplier: 'Supplier',
        chargeDetails: 'Charge Details'
      },
      match: {
        pending: 'Click "Query Matched Prices" to get rate information',
        empty: 'No {type}',
        failed: 'Failed to match prices',
        noMatchedPrice: 'No matched prices'
      },
      validation: {
        upload: 'Please upload {field}',
        select: 'Please select {field}',
        input: 'Please enter {field}',
        checkRequired: 'Please check required fields and field rules',
        passed: 'Validation passed',
        deadlineFutureRequired: 'The quotation deadline must be later than the current time'
      },
      messages: {
        resetTip: 'Please adjust the current form fields as needed'
      }
    }
  },

  // ======== AI Inquiry Recognition Inline Panel ========
  aiInquiryRecognition: {
    upload: {
      title: 'Click or drag to upload inquiry file',
      supportedFormats: 'Supports JPG/PNG/PDF/Excel/Word formats'
    },
    warning: 'If only inquiring about pre-port and last-mile charges, please clearly mark "Pre-port" and "Last-mile" respectively before the information provided.',
    textPlaceholder: 'Please paste the text content to be recognized, for example:\nFrom CNSHA/Shanghai to USLAX/Los Angeles\nCarrier: Maersk\nContainer: 2x20GP + 1x40HC\nWeight: 1200 KGS\nDirect route, Service terms: DDP\nCargo type: General cargo;\nShanghai Freight Forwarding Service Co., Ltd.\n\nStuffing Point: The system will automatically parse province, city, district, and street information. Detailed addresses will be filled into the detailed address field;\n\nLast-mile Delivery Address: If the system recognizes a warehouse code, it will automatically select the warehouse. In other cases, it will be set as a third-party address and parse the address and postal code;',
    startButton: 'Start Recognition',
    messages: {
      emptyInput: 'Please upload a file or enter text content',
      error: 'AI recognition failed, please try again',
      filledCount: 'AI recognition completed, {filled} fields filled this time',
      noResult: 'No valid information recognized, please check the input content'
    }
  },

  // ======== Address Allocation Modal ========
  addressAllocModal: {
    title: 'Address Allocation',
    description: 'The following address cannot be automatically identified. Please manually allocate it to the corresponding field:',
    unknownAddress: 'Address',
    selectPlaceholder: 'Please select',
    options: {
      stuffing: 'Pre-port Stuffing Point',
      delivery: 'Last-mile Delivery Address'
    },
    cancel: 'Cancel',
    confirm: 'Confirm Backfill'
  }
}
